'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = require('reselect');

var _defaults = require('../defaults');

/**
 * Gets the current url to be used for the application
 * @param {Map<*, *>} state The application state. Defaults to the default en-gb sportsbook if none is set
 * @returns {string} The url
 */
var getCurrentUrl = function getCurrentUrl(state) {
  return state.getIn(['settings', 'url'], _defaults.DEFAULT_URL);
};

/**
 * Get the current url
 * @param {Map} state The redux state
 * @return {String} The application url
 */

var getCurrentUrlSelector = (0, _reselect.createSelector)([getCurrentUrl], function (url) {
  return url;
});

exports.default = getCurrentUrlSelector;
//# sourceMappingURL=currentUrl.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-global-settings/dist/main/selectors/currentUrl.js
// module id = 524
// module chunks = 0